import { useEffect } from 'react';

type Axis = 'x' | 'y' | undefined;

function useHideGlobalScrollbar(hideStatus: boolean, axis?: Axis) {
  useEffect(() => {
    const p = axis === 'y' ? 'overflowY' : axis === 'x' ? 'overflowX' : 'overflow';
    document.body.style[p] = hideStatus ? 'hidden' : 'auto';
  }, [hideStatus]);
}

export default useHideGlobalScrollbar;
